import { primitiveColors } from '../colors';
import { ComponentColors } from '../component-colors';
import { semanticColors } from './semantic-colors';

export const componentColors: ComponentColors = {
    alert: {
        bg: semanticColors.background.default,
    },
    modals: {
        layerFigma: semanticColors.background.default,
        // Figma alias: defa-blue primitive
        network: { accent: primitiveColors.defaBlue[500] },
        priceZone: { fgMapNumbers: semanticColors.foreground.darkDefa },
    },
    rolePill: {
        fgGuest: primitiveColors.urbanOrange[500],
        fgSwapAndOwner: primitiveColors.red[500],
        borderSwapAndOwner: primitiveColors.red[500],
        fgFavorite: primitiveColors.gray[500],
    },
    controls: {
        checkbox: { bgActive: semanticColors.foreground.darkDefa },
        toggle: { bgActive: semanticColors.background.success },
        radioButton: { fgActive: semanticColors.foreground.default },
        slider: {
            fgAmount: semanticColors.foreground.subtle,
            fgTotalAmount: semanticColors.background.default,
            fgIcons: semanticColors.foreground.default,
        },
    },
    chargerStatus: {
        fgDisabled: semanticColors.background.disabled,
        fgIconDisabled: semanticColors.foreground.disabled,
        loadingIconSecondary: primitiveColors.gray.fff,
        fgNotAvailable: semanticColors.background.disabled,
    },
    avatar: {
        bgColoredIcon: semanticColors.background.alternative,
        bgColoredInitials: primitiveColors.red[500],
    },
    toggleButton: {
        withText: {
            borderDefault: semanticColors.border.light,
            fgDefault: semanticColors.foreground.default,
            bgSelected: semanticColors.background.inverted,
            fgSelected: semanticColors.foreground.darkDefa,
        },
        withIcon: {
            bg: semanticColors.background.subtle,
        },
    },
    button: {
        primary: {
            bgDefault: semanticColors.foreground.default,
            fgDefault: semanticColors.background.default,
            bgAlternativeDefault: semanticColors.background.subtle,
            fgAlternativeDefault: semanticColors.foreground.default,
        },
        secondary: {
            borderDefault: semanticColors.border.subtle,
            fgDefault: semanticColors.foreground.default,
            fgAlternativeDefault: semanticColors.foreground.light,
        },
        important: {
            bgImportant: semanticColors.background.error,
            fgImportant: semanticColors.foreground.default,
        },
    },
    card: {
        error: {
            bgError: semanticColors.background.error,
            fgError: semanticColors.foreground.default,
        },
        alternative: {
            bgAlternative: semanticColors.background.alternative,
        },
    },
    tab: {
        fgActive: primitiveColors.red[500],
    },
    connectorState: {
        bgUnavailable: primitiveColors.gray[850],
    },
};
